<script>
import { menuItems } from "./menu";
export default {
  name: "SibeBarV2",
  components: {},
  data() {
    return {
      menuItems: menuItems,
      menuItem: "",
      subItem: "",
      sideBar: true,
      hideSideBar: false,
      myWindow: null,
    };
  },
  mounted() {
    this.myWindow = window;
    let hreflink = window?.location.href.split("#");
    hreflink = hreflink[1];
    this.menuItems.forEach((item) => {
      if (item.subItems) {
        item.subItems.forEach((subItem) => {
          if (subItem.link && subItem.link == hreflink) {
            this.menuItem = item.label;
            return;
          } else if (subItem.subItems) {
            subItem.subItems.forEach((subsubitem) => {
              if (subsubitem.link == hreflink) {
                this.menuItem = item.label;
                this.subItem = subItem.label;
              }
            });
          }
        });
      }
    });
  },
  methods: {
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    toggleMenu(v) {
      if (this.menuItem == v) {
        this.menuItem = "";
      } else {
        this.menuItem = v;
      }
    },
    toggleSubItem(v, event) {
      event.stopPropagation();
      if (this.subItem == v) {
        this.subItem = "";
      } else {
        this.subItem = v;
      }
    },
    handleHideSideBar() {
      this.sideBar = !this.sideBar;
      this.hideSideBar = !this.hideSideBar;
    },
    handleMouseOver() {
      if (!this.sideBar && this.hideSideBar == true) {
        this.hideSideBar = false;
      }
    },
    handleMouseLeave() {
      if (!this.sideBar && this.hideSideBar == false) {
        this.hideSideBar = true;
      }
    },
    getUsername() {
      let user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        return user.user.name;
      }
    },
  },
  watch: {},
};
</script>

<template>
  <div
    class="my-container"
    :class="{
      'my-container-show': !hideSideBar,
      'my-container-hide': hideSideBar,
    }"
    style="position: sticky"
  >
    <div class="my-sidebar bg-white shadow-lg" style="transition: all 0.4s">
      <div style="height: 100px">
        <a
          href="#/"
          class="logo logo-light"
          style="
            border-bottom: 1px solid rgb(247, 247, 247);
            position: relative;
          "
        >
          <div
            class="logo-lg d-flex"
            :style="{ height: hideSideBar ? '60px' : '100px' }"
          >
            <img
              src="@/assets/Dil-Foods-new-logo.png"
              alt
              height="100%"
              style="margin: auto"
            />
          </div>
        </a>
      </div>
      <button
        style="
          border: 0;
          height: 40px;
          width: 40px;
          border-radius: 50%;
          position: absolute;
          right: -7px;
          transform: translateY(-50%);
        "
        @click="handleHideSideBar()"
      >
        <i
          class="fa fa-angle-left"
          :style="{ rotate: hideSideBar ? '180deg' : '0deg' }"
        ></i>
      </button>
      <ul
        class="my-ordered-menulist"
        @mouseover="handleMouseOver()"
        @mouseleave="handleMouseLeave()"
      >
        <template v-for="item in menuItems">
          <template
            v-if="
              $store.state.authfack.user.permissions
                .map((p) => p.name)
                .includes(item.permission) ||
              $store.state.authfack.user.roles.filter(
                (f) => f.name == 'SuperAdmin'
              ).length > 0
            "
          >
            <li
              v-if="!item.isTitle && !item.isLayout"
              :class="{
                'my-ordered-menulistitems': true,
                'my-ordered-menulistitems-active':
                  item.label === menuItem && !hideSideBar,
              }"
              @click="toggleMenu(item.label)"
              :key="item.id"
            >
              <div
                class="d-flex"
                style="
                  justify-content: space-between;
                  padding-right: 10px;
                  padding-block: 10px;
                  cursor: pointer;
                "
              >
                <div style="display: flex; align-items: center; gap: 10px">
                  <div
                    style="transition: all 0.4s"
                    :style="{
                      'font-size': hideSideBar ? '20px' : '14px',
                      width: hideSideBar ? '30px' : '20px',
                    }"
                  >
                    <i class="fa fa-map" v-if="item.label == 'Locations'"></i>
                    <i
                      class="fa fa-boxes"
                      v-else-if="item.label == 'Inventory'"
                    ></i>
                    <i
                      class="fa fa-warehouse"
                      v-else-if="item.label == 'Warehouse Mngmnt'"
                    ></i>
                    <i class="fa fa-bars" v-else></i>
                  </div>
                  <p style="margin-bottom: 0px; min-width: max-content">
                    {{ item.label }}
                  </p>
                </div>
                <span
                  ><i
                    class="fa fa-angle-down arrow"
                    :class="{ arrowactive: item.label == menuItem }"
                  ></i
                ></span>
              </div>
              <ul
                :class="{
                  'my-ordered-sublist': true,
                }"
                :key="item.id"
              >
                <!-- v-if="hasItems(item)" -->

                <li
                  :class="{
                    'my-ordered-sublistitems':
                      $store.state.authfack.user.permissions
                        .map((p) => p.name)
                        .includes(subitem.permission) ||
                      $store.state.authfack.user.roles.filter(
                        (f) => f.name == 'SuperAdmin'
                      ).length > 0 ||
                      (subitem.permission == ''
                        ? $store.state.authfack.user.permissions.filter(
                            (f) => f.name == item.permission
                          ).length > 0
                        : false),
                  }"
                  :key="subitem.id"
                  v-for="subitem in item.subItems"
                  @click="toggleSubItem(subitem.label, $event)"
                >
                  <template
                    v-if="
                      $store.state.authfack.user.permissions
                        .map((p) => p.name)
                        .includes(subitem.permission) ||
                      $store.state.authfack.user.roles.filter(
                        (f) => f.name == 'SuperAdmin'
                      ).length > 0 ||
                      (subitem.permission == ''
                        ? $store.state.authfack.user.permissions.filter(
                            (f) => f.name == item.permission
                          ).length > 0
                        : false)
                    "
                  >
                    <router-link
                      :to="subitem.link"
                      v-if="!hasItems(subitem)"
                      class="side-nav-link-ref"
                      id="id-side-nav-link-ref"
                      :style="`color:${
                        myWindow?.location.href.split('#')[1] == subitem.link
                          ? '#000'
                          : 'gray'
                      };font-size : ${
                        myWindow?.location.href.split('#')[1] == subitem.link
                          ? '15px'
                          : ''
                      }`"
                      >{{ subitem.label }}</router-link
                    >
                    <div
                      v-if="hasItems(subitem)"
                      style="display: flex; align-items: center; gap: 10px"
                    >
                      <a
                        class="side-nav-link-a-ref has-arrow"
                        href="javascript:void(0);"
                        >{{ subitem.label }}</a
                      >
                      <span
                        ><i
                          class="fa fa-angle-down arrow"
                          :class="{ arrowactive: subitem.label == subItem }"
                        ></i
                      ></span>
                    </div>
                  </template>
                  <ul
                    :class="{
                      'my-ordered-sublist': true,
                      'my-ordered-subsublist': true,
                      'my-ordered-subsublist-active':
                        subitem.label == subItem && !hideSideBar,
                    }"
                    :key="item.id"
                  >
                    <li
                      :class="{
                        'my-ordered-sublistitems my-ordered-subsublist-items':
                          $store.state.authfack.user.permissions
                            .map((p) => p.name)
                            .includes(subSubitem.permission) ||
                          $store.state.authfack.user.roles.filter(
                            (f) => f.name == 'SuperAdmin'
                          ).length > 0,
                      }"
                      :key="subSubitem.id"
                      v-for="subSubitem in subitem.subItems"
                    >
                      <template
                        v-if="
                          $store.state.authfack.user.permissions
                            .map((p) => p.name)
                            .includes(subSubitem.permission) ||
                          $store.state.authfack.user.roles.filter(
                            (f) => f.name == 'SuperAdmin'
                          ).length > 0
                        "
                      >
                        <router-link
                          :to="subSubitem.link"
                          class="side-nav-link-ref my-ordered-subsublist-items-link"
                          :style="`color:${
                            myWindow?.location.href.split('#')[1] ==
                            subSubitem.link
                              ? '#000'
                              : 'gray'
                          };font-size : ${
                            myWindow?.location.href.split('#')[1] ==
                            subSubitem.link
                              ? '15px'
                              : ''
                          }`"
                          >{{ subSubitem.label }}</router-link
                        >
                      </template>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </template>
        </template>
      </ul>
      <div class="user-container">
        <div class="user">
          <img
            class="rounded-circle header-profile-user"
            src="@/assets/images/user-icon.png"
            alt="Header Avatar"
            style="height: 41px"
          />
          <span class="">{{ getUsername() }}</span>
        </div>
        <div class="logout" v-if="!hideSideBar">
          <router-link to="/logout">
            <a class="dropdown-item text-danger" href="javascript:void(0);">
              <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
              Log out
            </a>
          </router-link>
        </div>

      </div>
    </div>
  </div>
</template>

<style>
.my-container {
  height: 100vh;
  padding: 10px;
  transition: all 0.5s;
}
.my-container-show {
  width: 280px;
}
.my-container-hide {
  width: 80px;
}
.my-sidebar {
  height: 100%;
  border-radius: 10px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 20px;
  overflow: auto;
  user-select: none;
}
.my-sidebar::-webkit-scrollbar {
  width: 0px;
}
.my-ordered-menulist {
  height: 60vh;
  list-style-type: none;
  padding-left: 15px;
  padding-right: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 5px;
  margin-top: 50px;
}
.my-ordered-menulist::-webkit-scrollbar {
  width: 3px;
  background-color: rgb(241, 245, 247);
}
.my-ordered-menulist::-webkit-scrollbar-thumb {
  background-color: rgb(171, 171, 171);
  border-radius: 4px;
}
.my-ordered-menulist::-webkit-scrollbar-track {
  background-color: white;
}
.my-ordered-menulistitems {
  padding-inline: 10px;
  border-radius: 5px;
  transition: all 0.1s;
  font-size: 15px;
  overflow: hidden;
  height: 40px;
  width: 230px;
}
.my-ordered-menulistitems-active {
  height: max-content;
  background-color: rgb(241, 245, 247);
}
.my-ordered-menulistitems:hover {
  background-color: rgb(241, 245, 247);
}
.arrow {
  transition: all 0.2s;
}
.arrowactive {
  rotate: 180deg;
  transition: all 0.2s;
}
.my-ordered-sublist {
  list-style-type: none;
  font-size: 14px;
  padding-left: 40px;
  transition: all 1s;
  padding-bottom: 0px;
  box-sizing: border-box;
  transition: all 1s !important;
}
.my-ordered-sublistitems {
  padding-block: 5px;
  transition: all 0.1s;
  box-sizing: content-box;
  height: max-content;
  overflow: hidden;
}

.my-ordered-sublistitems-show {
  font-size: 15px;
  color: black;
  transition: all 0.1s;
}
.my-ordered-subsublist {
  display: none;
}
.my-ordered-subsublist-active {
  display: block;
}
.my-ordered-subsublist-items {
  margin-left: -20px;
}
.my-ordered-subsublist-items:hover {
  color: black !important;
}
.side-nav-link-ref {
  transition: all 0.1s;
  color: gray;
}
#id-side-nav-link-ref:hover {
  color: black !important;
}
.side-nav-link-a-ref {
  color: gray !important;
}
.side-nav-link-a-ref:hover {
  color: black !important;
}
.my-ordered-subsublist-items-link:hover {
  color: black !important;
}
.user-container {
  padding-left: 20px;
  font-size: 16px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid rgb(247, 247, 247);
}
.user {
  display: flex;
  gap: 20px;
  align-items: center;
  font-size: 18px;
  color: black;
}
.logout {
  display: flex;
  gap: 10px;
  color: rgb(190, 60, 60);
  align-items: center;
  margin-left: 10px;
  margin-top: 5px;
  background-color: rgba(190, 60, 60, 0.05);
  width: max-content;
  border-radius: 5px;
  cursor: pointer;
}
.logout:hover {
  color: rgb(190, 70, 70);
  background-color: rgba(190, 60, 60, 0.2);
  cursor: pointer;
}
.logout > p {
  margin-bottom: 0px;
}
</style>
